import { getTimeZoneNiceName } from '../utils/getTimeZoneNiceName'

export const USER_TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone
export const USER_TIME_ZONE_NAME = getTimeZoneNiceName(USER_TIME_ZONE)
